// @flow
import * as React from 'react'
import DefaultMessagesManager from '../core/DefaultMessagesManager'

// Types
export type Props = {
  locale: string,
  manager: DefaultMessagesManager,
  messages?: Object,
  children?: React.Node,
}

// Utils
const Provider = ({ children }: { children?: React.Node }) => children || null

/**
 * Wrapper around `react-intl` which adds messages management
 * and async messages loading when message translation requested.
 * It loads translations by domains. When locale changed it wipe
 * all domains and messages and load active domains for the new locale.
 */
class IntlProvider extends React.Component<Props> {
  static defaultProps = {
    messages: {},
    locale: 'en-us',
  }

  constructor(props: Props, context: any) {
    super(props, context)
    this.props.manager.changeLocale(this.props.locale)
  }

  getChildContext() {
    return { mzIntl: this.props.manager }
  }

  UNSAFE_componentWillReceiveProps(nextProps: any) {
    if (nextProps.locale !== this.props.locale) {
      nextProps.manager.changeLocale(nextProps.locale)
    }
    if (nextProps.messages !== this.props.messages) {
      nextProps.manager.appendMessages(nextProps.messages)
    }
  }

  render() {
    return (
      <Provider key={`${this.props.locale}`}>{this.props.children}</Provider>
    )
  }
}

IntlProvider.childContextTypes = {
  mzIntl: () => null,
}

export default IntlProvider
